import React, { PureComponent } from "react";

import { BrowserRouter as Router, Route,Redirect } from "react-router-dom";
import SideMenu from 'components/SideMenu';
import MinisterMail from 'pages/exchange/ministerMail'
import ReplyDigest from 'pages/exchange/replyDigest'
import Consultation from 'pages/exchange/consultation'
import DisciplinaryInspection from 'pages/exchange/disciplinaryInspection'
import 'element-theme-default';
require("./index.css");


export default class Exchange extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      dataList: [
        {
            txt: "部长信箱",
            type:1,
            component:MinisterMail,
            path: '/entrance/exchange/ministerMail'
          },
          {
            txt: "回复选登",
            type:2,
            component:ReplyDigest,
            path: '/entrance/exchange/replyDigest'
          },
          {
            txt: "意见征求",
            type:3,
            component:Consultation,
            path: '/entrance/exchange/consultation'
          },
          {
            txt: "纪检监察举报",
            type:4,
            component:DisciplinaryInspection,
            path: '/entrance/exchange/disciplinaryInspection'
          }
      ]
    }
  }



  render() {
    
    return (
      <div>
        {/* 内容 */}
        <div className="content">
          <div className="container clear">
            <SideMenu title={'互动交流'} data={this.state.dataList} tabListWidth={140}/>
              
            {
                  this.state.dataList.map((item,index)=> {
              
                      return(
                          <Route path={item.path} component={item.component} />
                      )
                    
                  })
            }
              <Redirect from="/entrance/exchange" to="/entrance/exchange/ministerMail" />
          </div>
        </div>
        {/* 内容 */}
      </div>
    );
  }
}
